/*
 *
 * Virtual Market
 * metrics-api - Servicios
 *
 * RYNDEM 2017
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'metrics-api';

/*********************** obtener metricas por mercado ***********************/
export function getMetricsByMarket(token, market) {
  DEBUG && console.log(OBJECT_ID + "@getMetricsByMarket: ");

  let requestUrl = `${API_URL}/metricas/mercado/${market}`;
  DEBUG && console.log(OBJECT_ID  + "@getMetricsByMarket: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "get",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** enviar resultados de las metricas ***********************/
export function sendMetricsUser(token, term) {
  DEBUG && console.log(OBJECT_ID + "@sendMetricsUser: ");

  let requestUrl = `${API_URL}/medicionesUsuario`;
  DEBUG && console.log(OBJECT_ID  + "@sendMetricsUser: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(responseMetricsUser => ({ responseMetricsUser }))
    .catch(errorMetricsUser => ({ errorMetricsUser }))
}

/*********************** enviar resultados de las metricas ***********************/
export function sendMetricsProducts(token, term) {
  DEBUG && console.log(OBJECT_ID + "@sendMetricsProducts: ");

  let requestUrl = `${API_URL}/medicionesProducto`;
  DEBUG && console.log(OBJECT_ID  + "@sendMetricsProducts: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(responseMetricsProducts => ({ responseMetricsProducts }))
    .catch(errorMetricsProducts => ({ errorMetricsProducts }))
}



// WEBPACK FOOTER //
// ./src/services/metrics-api.js